"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FmsUnitSuggestions = void 0;
const react_1 = __importDefault(require("react"));
const base_suggestions_1 = require("./base-suggestions");
const highlight_words_1 = require("./highlight-words");
class FmsUnitSuggestions extends base_suggestions_1.BaseSuggestions {
    constructor() {
        super(...arguments);
        this.loadSuggestionsUrl = 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/fms_unit';
        this.getLoadSuggestionsData = () => {
            const { count, unitCode } = this.props;
            const { query } = this.state;
            return {
                query: unitCode || query,
                count: count || 10,
            };
        };
        this.getSuggestionKey = (suggestion) => suggestion.value;
        this.renderOption = (suggestion) => {
            const { renderOption, highlightClassName } = this.props;
            const { query } = this.state;
            return renderOption ? (renderOption(suggestion, query)) : (react_1.default.createElement("div", null,
                react_1.default.createElement(highlight_words_1.HighlightWords, { highlightClassName: highlightClassName || 'react-dadata--highlighted', words: this.getHighlightWords(), text: suggestion.value })));
        };
    }
}
exports.FmsUnitSuggestions = FmsUnitSuggestions;
